import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { BsInfoCircle } from "react-icons/bs";
import { AllNewJobsListAction } from "../../../Redux/action/AllNewJobsListAction";
import Logo from "../../../images/ebench_logo.png";
import TableHeader from "../../Common/TableHeader";
import { FaBuilding } from "react-icons/fa";
import Pagination from "../../Common/Pagination/Pagination";
import BackButton from "../../Common/BackButton/BackButton";

const AllNewJobsList = () => {
  const [currentPage, setcurrentPage] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(20);
  const [pageNumberLimit, setpageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const userInfo = useSelector(
    (state) => state?.AllNewJobsListData?.result?.content
  );
  const totalPages = useSelector(
    (state) => state?.AllNewJobsListData?.result?.totalPages
  );
  const dispatch = useDispatch();
  const { userResult } = useSelector((state) => state.Auth);
  let vendorId = userResult?.vendorid;

  useEffect(() => {
    const content = {
      vendorId,
      pageNumber,
      pageSize: 10,
      //   filter: "ALL",
      search,
    };
    dispatch(AllNewJobsListAction(content));
  }, [vendorId, pageNumber, search, dispatch]);

  const handleClick = (e) => {
    setcurrentPage(Number(e.target.id));
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(userInfo?.length / itemsPerPage); i++) {
    pages.push(i);
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = userInfo?.slice(indexOfFirstItem, indexOfLastItem);
  const newData = userInfo;

  const renderPageNumbers = pages.map((number) => {
    if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
      return (
        <li
          key={number}
          id={number}
          onClick={handleClick}
          className={currentPage === number ? "active" : null}
        >
          {number}
        </li>
      );
    } else {
      return null;
    }
  });

  const handleNextbtn = () => {
    setcurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageNumberLimit) {
      setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePrevbtn = () => {
    setcurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  let pageIncrementBtn = null;
  if (pages.length > maxPageNumberLimit) {
    pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
  }

  let pageDecrementBtn = null;
  if (minPageNumberLimit >= 1) {
    pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
  }

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  return (
    <div className="jobs_wrapper">
      <>
        <div className="mt-5 mt-md-0 d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between gap-3">
          <div className="form-outline w-75 w-md-50 w-lg-25 mt-4 mt-md-0 mx-auto">
            <BackButton />
            <input
              type="search"
              className="form-control "
              placeholder="Search by job"
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </>

      <div className="jobs_container">
        <div className="d-flex flex-column flex-md-row gap-4 container mt-4">
          <div className="job_cards_container">
            {currentItems?.map((item) => (
              <Link to={`/view_job/${item.jobId}`} key={item.jobId}>
                <div className="job_card">
                  <div className="left_border"></div>
                  <div className="p-3 w-100 pb-1">
                    <div className="jc_top d-flex justify-content-between">
                      <p>{item?.jobTitle}</p>
                      <p className="jc_company" style={{ fontWeight: "600" }}>
                        <span className="me-1" style={{}}></span>
                        JOB ID : {item?.jobUuid}
                      </p>
                    </div>

                    <div className="jc_desc">{item.jobDescription}</div>

                    <div className="jc_bottom">
                      {item?.workType != "REMOTE" ? (
                        <p className="" style={{ marginRight: "50px" }}>
                          Location:{" "}
                          <span className="text-secondary fw-normal">
                            {item.jobLocation || item?.workType}
                          </span>{" "}
                        </p>
                      ) : (
                        <p className="" style={{ marginRight: "50px" }}>
                          {" "}
                          Location: {item?.workType}
                        </p>
                      )}
                      <p style={{ marginRight: "50px" }}>
                        Experience:{" "}
                        <span className="text-secondary fw-normal">
                          {item.minimumExperience?.includes("0")
                            ? `Fresher - ${item.maximumExperience
                                ?.replace(/years?/i, "")
                                ?.trim()} years`
                            : `${item.minimumExperience
                                ?.replace(/years?/i, "")
                                ?.trim()} - ${item.maximumExperience
                                ?.replace(/years?/i, "")
                                ?.trim()} years`}
                        </span>
                      </p>
                      <p>
                        Job Posted on :{" "}
                        <span className="text-secondary fw-normal">
                          {(() => {
                            try {
                              if (!item?.postedDate) return "N/A";

                              const [datePart, timePart] =
                                item?.postedDate?.split(" ");
                              if (!datePart) return "N/A";

                              const [day, month, year] = datePart?.split("-");
                              if (!day || !month || !year) return "N/A";

                              if (!timePart) {
                                return `${day}-${month}-${year}`;
                              }

                              const [hour, minute] = timePart?.split(":");
                              if (!hour || !minute)
                                return `${day}-${month}-${year}`;

                              const dateObj = new Date(
                                year,
                                month - 1,
                                day,
                                hour,
                                minute
                              );
                              if (isNaN(dateObj.getTime())) return "N/A";

                              const hours = dateObj.getHours();
                              const minutes = dateObj
                                .getMinutes()
                                .toString()
                                .padStart(2, "0");
                              const ampm = hours >= 12 ? "PM" : "AM";
                              const formattedHour =
                                hours % 12 === 0 ? 12 : hours % 12;

                              return `${day}-${month}-${year} ${formattedHour}:${minutes} ${ampm}`;
                            } catch (err) {
                              return "N/A";
                            }
                          })()}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
            {currentItems?.length === 0 && (
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                <h5>No jobs found matching your profile</h5>
              </div>
            )}
          </div>

          <div className="jc_notes_container p-3 mb-3">
            <p className="jc_notes_head">Important Notes!</p>
            <div className="line_divide"></div>
            <div className="jc_notes mt-3">
              <p>
                AI That Understands Hiring: eBench uses intelligent algorithms
                to match you with the right candidates—fast, accurately, and
                with zero guesswork.
              </p>
              <p>
                Vetted Professionals Only: Every candidate is thoroughly
                assessed for skills, experience, and fit—saving you time and
                ensuring quality.
              </p>
              <p>
                All-in-One Hiring Platform: Post jobs, manage candidates,
                schedule interviews, and onboard—all from one intuitive
                dashboard.
              </p>
              <p>
                Reduce Time & Cost: Cut hiring time by up to 70% and avoid the
                costs of bad hires with data-backed decision-making.
              </p>
              <p>
                Global Reach, Local Compliance: Find top remote talent while
                ensuring full compliance with employment laws across regions.
              </p>
              <p>
                Custom Workflows: Tailor the platform for every industry and
                internal hiring processes—whether you're a startup or a large
                enterprise.
              </p>
            </div>
          </div>
        </div>
      </div>
      {totalPages > 0 && (
        <Pagination
          totalPages={totalPages}
          currentPage={pageNumber}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default AllNewJobsList;
